import { Theme } from '@chakra-ui/react'

type Params = {
  theme: Theme
}

const input = {
  parts: ['field'],
  baseStyle: {
    field: {
      '@media (max-width: 480px)': {
        fontSize: '16px',
      },
    },
  },
  sizes: {
    xs: {
      field: {
        rounded: 'sm',
      },
    },
  },
  variants: {
    outline: ({ theme }: Params) => {
      return {
        field: {
          bg: 'light',
          borderColor: 'borderColor',
          borderRadius: 'md',
          _focus: {
            borderColor: 'transparent',
            boxShadow: `0 0 0 3px ${theme.colors.blue[400]}`,
          },
        },
      }
    },

    ghost: ({}: Params) => {
      return {
        field: {
          bg: 'light',
        },
      }
    },
  },
  defaultProps: {},
}

export default input
